import store from '../../store';

export default (text, options = {}) => {
  // options could accept properties:
  // withSpan: true – adds a <span class=""> wrapper before text
  // white: true – makes the span wrapper white

  const currency = store.state.global.currency;
  if (text && (text !== '0' || options.zeros)) {
    if (options.withSpan)
      return `<span class="currency currency-mr4${
        options.white ? ' currency-mr4-white' : ''
      }">${currency}</span>${text}`;
    else return `${currency} ${text}`;
  }
  return '';
};
